export const CREATE_TEMP_USER = 'CREATE_TEMP_USER';
export const CHECK_TEMP_USER_SMS_KEY = 'CHECK_TEMP_USER_SMS_KEY';
export const SEND_TEMP_USER_SMS_KEY = 'SEND_TEMP_USER_SMS_KEY';
